export enum IncentiveWageType {
  FixedAmount = 0,
  ReconciledMiles = 1,
  SettlementMiles = 2,
  Hours = 3,
  SettlementDayMiles = 4
  //HOSOverNight = 10,
  //PerShift = 11
}

export const IncentiveWageTypeMapping: Record<IncentiveWageType, string> = {
  [IncentiveWageType.FixedAmount]: 'Fixed Amount',
  [IncentiveWageType.ReconciledMiles]: 'Reconciled Logs',
  [IncentiveWageType.SettlementMiles]: 'Settlement Logs',
  [IncentiveWageType.Hours]: 'Hours',
  [IncentiveWageType.SettlementDayMiles]: 'Settlement Day Miles (Holiday)'
  //[IncentiveWageType.HOSOverNight]: 'Overnight Pay (HOS)',
  //[IncentiveWageType.PerShift]: 'Per Shift'
};

export const IncentiveWagesBasedOnMileageRate: Array<IncentiveWageType> = [
  IncentiveWageType.ReconciledMiles,
  IncentiveWageType.SettlementMiles,
  IncentiveWageType.SettlementDayMiles
];

export const IncentiveWagesBasedOnHours: Array<IncentiveWageType> = [IncentiveWageType.Hours];

export const IncentiveWagesBasedOnAmount: Array<IncentiveWageType> = [
  IncentiveWageType.FixedAmount
  //IncentiveWageType.HOSOverNight,
  //IncentiveWageType.PerShift
];
